'use client'

import { SessionProvider } from "next-auth/react"
import { HelpChatSocketProvider } from "@/lib/HelpChatSocketProvider"
import { OrderSocketProvider } from "@/lib/OrderSocketProvider"

export default function Provider({ children, session }) {
  return (
    <SessionProvider session={session}>
      <HelpChatSocketProvider>
        <OrderSocketProvider>
          {children}
        </OrderSocketProvider>
      </HelpChatSocketProvider>
    </SessionProvider>
  )
}